import { connect } from 'react-redux';
import IAppState from '../../../IAppState';
import {
    ISummaryComponentPropsData,
    ISummaryComponentPropsFunctions,
} from '../props/ISummaryComponentProps';
import SummaryComponent from '../components/SummaryComponent';
import Actions from '../state/act-summary';
import INewJob from '../interfaces/INewJob';
import { summaryInitialState } from '../../../initial-state';
import { allToFile } from '../FileConverters';
import { ll_fetch } from '../../../tools';
import { clientUrlPrefix } from '../../../settings';
import ActMain from "../../../act-main";

function runJob(dispatch: any, newJob: INewJob, browserHistory: any) {
    dispatch(ActMain.setResultsLoaded(false));
    dispatch(Actions.newJobRequest());

    console.log('newjob' + JSON.stringify(newJob)); //debug print

    ll_fetch(`/api/addNewJob`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },

        body: JSON.stringify(newJob),
    })
        .then((r) => {
            if (!r.ok) {
                dispatch(Actions.newJobFailure());
                console.error('fetch failed');
                return;
            }

            r.text().then((jobId) => {
                if(jobId == ""){
                    alert("Due to the high computational demands of the FireProt workflow, we were forced to limit a number of calculations per user. You already have three running jobs, please try again later.");
                    return;
                }
                dispatch(ActMain.resetMainState());
                browserHistory.push(`${clientUrlPrefix}/job/${jobId}`);
            });
        })
        .catch((err) => {
            dispatch(Actions.newJobFailure());
            alert('Job submission failed. Please try it again later.');
            console.error('fetch failed', err);
        });

    // dispatch(Actions.newJobRequest());
    // ll_fetch('/api/addNewJob', {
    //     method: "POST",
    //     headers: {
    //         "Content-Type": "application/json",
    //     },
    //     body: JSON.stringify(newJob),
    // })
    //     .then(r => {
    //         if (!r.ok) {
    //             dispatch(Actions.newJobFailure());
    //             console.error("fetch failed");
    //             return;
    //         }
    //         r.text().then(jobId => {
    //             dispatch(Actions.newJobSuccess(jobId));
    //             browserHistory.push(`${clientUrlPrefix}/job/${jobId}`);
    //         });
    //     })
    //     .catch(err => {
    //         dispatch(Actions.newJobFailure());
    //         alert('Job submission failed. Please try it again later.');
    //         console.error("fetch failed", err);
    //     });
}

function showResults(exampleJobId: string, browserHistory: any) {
    browserHistory.push(`${clientUrlPrefix}/job/${exampleJobId}`);
}

function goHome(browserHistory: any) {
    browserHistory.replace(`${clientUrlPrefix}/`);
}

interface Selection {
    lowRiskDesign: boolean;
    highRiskDesign: boolean;
    ancestralDesign: boolean;
    forceFieldMutations: boolean;
    bFactorAnalysis: boolean;
    consensusMutations: boolean;
    isUserDefined: boolean;
}

// https://stackoverflow.com/questions/17781472/how-to-get-a-subset-of-a-javascript-objects-properties
const mapStateToProps = (state: IAppState): ISummaryComponentPropsData => {
    const sumSt = state.summaryState;
    const mainSt = state.mainState;
    const sel: Selection = {
        lowRiskDesign: mainSt.lowRiskDesign,
        highRiskDesign: mainSt.highRiskDesign,
        ancestralDesign: mainSt.ancestralDesign,
        forceFieldMutations: mainSt.forceFieldMutations,
        bFactorAnalysis: mainSt.bFactorAnalysis,
        consensusMutations: mainSt.consensusMutations,
        isUserDefined: mainSt.calculation == 0 ? true : false,
    };
    const pdb = mainSt.pdbIdField;
    const inputData = mainSt.inputDataType;
    const model = inputData == 0 ? false : true;
    const mutations = mainSt.userDefined;
    const selectedAnnotations = mainSt.selectedSiteAnotations;
    const uniprot = mainSt.uniprotIdField;
    
    const mapping = mainSt.selectedStructureInfo !== null ? mainSt.selectedStructureInfo["chains"] + ":" + mainSt.selectedStructureInfo["original"] : "";
    
    return {
        jobId: sumSt.jobId,
        jobTitle: sumSt.jobTitle,
        email: sumSt.email,
        sequence: sumSt.sequence,
        newJob: {
            ...(({ jobId, jobTitle, email, sequence, advancedOptions }) => ({
                jobId,
                jobTitle,
                email,
                sequence,
                advancedOptions,
            }))(state.mainState),
            selection: sel,
            pdb: pdb,
            model: model,
            userDefined: mutations,
            annotations: selectedAnnotations,
            uniprotId: uniprot,
            chainMapping: mapping,
            inputFileJson: JSON.stringify(allToFile(state)),
        },
        ...state.mainState,
        disabled: false,
        exampleJobId: sumSt.exampleJobId,
        noData: sumSt === summaryInitialState,
    };
};

const mapDispatchToProps = (
    dispatch: any,
    ownProps: { history: any }
): ISummaryComponentPropsFunctions => ({
    runJob: (newJob: INewJob) => runJob(dispatch, newJob, ownProps.history),
    showResults: (exampleJobId: string) =>
        showResults(exampleJobId, ownProps.history),
    goBack: () => ownProps.history.goBack(),
    goHome: () => goHome(ownProps.history),
});

const SummaryContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(SummaryComponent);

export default SummaryContainer;
